import CronGenerator from 'components/CronGenerator/CronGenerator';
import Text from 'components/Text/Text';
import { IItemForGetShortInfo } from 'types';
import ControlPointSelect from './components/ControlPointSelect';
import CountDownField from './components/CountDownField';
import DelayTimeField from './components/DelayTimeField';
import LaunchCountField from './components/LaunchCountField';
import ScheduleField from './components/ScheduleField/ScheduleField';
import TransitionTypeField from './components/TransitionTypeField/TransitionTypeField';
import {
	ICreateTeaserTotalSchedule,
	TCreateTeaserControlPoint,
	TCreateTeaserSelectedContentType,
	TCreateTeaserSelectedItem,
	TCreateTeaserTransitionType,
} from 'modules/Teasers/CreateTeaser/createTeaserState/createTeaserContext';
import React from 'react';
import style from './AdditionalFields.module.scss';

interface IAdditionalFields {
	selectedContentType: TCreateTeaserSelectedContentType;
	totalSchedules: ICreateTeaserTotalSchedule[];
	changeSchedule: (value: string) => void;
	changeAdditionalSchedule: (fieldId: string, value: string) => void;
	setSchedules: (value: ICreateTeaserTotalSchedule[]) => void;
	setTransitionType: (value: TCreateTeaserTransitionType) => void;
	setControlPoint: (value: TCreateTeaserControlPoint) => void;
	changeDelayTime: (value: string) => void;
	changeLaunchCount: (value: string) => void;
	changeCountDown: (value: string) => void;
	selectedRestaurants: string[];
	setTransitionDishCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishCategory: TCreateTeaserSelectedItem;
	setTransitionDishSubCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishSubCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionDishSubCategory: TCreateTeaserSelectedItem;
	setTransitionDishName: (value: TCreateTeaserSelectedItem) => void;
	setFetchedDishes: (value: IItemForGetShortInfo[]) => void;
	setTransitionGameCategory: (value: TCreateTeaserSelectedItem) => void;
	setFetchedGameCategories: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionGameCategory: TCreateTeaserSelectedItem;
	setTransitionGameName: (value: TCreateTeaserSelectedItem) => void;
	setFetchedGames: (value: IItemForGetShortInfo[]) => void;
	selectedTransitionType: TCreateTeaserTransitionType;
}

const AdditionalFields: React.FC<IAdditionalFields> = ({
	selectedContentType,
	totalSchedules,
	selectedRestaurants,
	changeAdditionalSchedule,
	changeSchedule,
	setTransitionType,
	setSchedules,
	changeCountDown,
	changeLaunchCount,
	changeDelayTime,
	setControlPoint,
	setTransitionDishCategory,
	setFetchedDishCategories,
	selectedTransitionDishCategory,
	setFetchedDishSubCategories,
	setTransitionDishSubCategory,
	selectedTransitionDishSubCategory,
	setFetchedDishes,
	setTransitionDishName,
	setTransitionGameCategory,
	setFetchedGameCategories,
	setTransitionGameName,
	selectedTransitionGameCategory,
	setFetchedGames,
	selectedTransitionType,
}) => {
	const advertisingContentType =
		selectedContentType === 'AdvertisingVideo' || selectedContentType === 'AdvertisingImage';
	const assistantContentType = selectedContentType === 'AssistantVideo' || selectedContentType === 'AssistantImage';
	const gameLaunchContentType =
		selectedContentType === 'GameLaunchVideo' || selectedContentType === 'GameLaunchImage';

	const showScheduler = advertisingContentType;
	const showAdditional = assistantContentType;
	const showAdditionalCountDown = gameLaunchContentType;
	const showTransition = advertisingContentType || assistantContentType;

	return (
		<>
			{showScheduler && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="scheduleHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<ScheduleField
						totalSchedules={totalSchedules}
						changeSchedule={changeSchedule}
						changeAdditionalSchedule={changeAdditionalSchedule}
						setSchedules={setSchedules}
					/>
					<CronGenerator />
				</div>
			)}
			{showAdditional && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="additionalHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<div className={style.row}>
						<ControlPointSelect setControlPoint={setControlPoint} />
						<DelayTimeField changeDelayTime={changeDelayTime} />
						<LaunchCountField changeLaunchCount={changeLaunchCount} />
					</div>
				</div>
			)}
			{showAdditionalCountDown && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="additionalHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<CountDownField changeCountDown={changeCountDown} />
				</div>
			)}
			{showTransition && (
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="transitionSectionHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<TransitionTypeField
						selectedRestaurants={selectedRestaurants}
						selectedTransitionDishCategory={selectedTransitionDishCategory}
						selectedTransitionDishSubCategory={selectedTransitionDishSubCategory}
						selectedTransitionGameCategory={selectedTransitionGameCategory}
						setTransitionType={setTransitionType}
						setTransitionDishCategory={setTransitionDishCategory}
						setFetchedDishCategories={setFetchedDishCategories}
						setFetchedDishSubCategories={setFetchedDishSubCategories}
						setTransitionDishSubCategory={setTransitionDishSubCategory}
						setTransitionDishName={setTransitionDishName}
						setFetchedDishes={setFetchedDishes}
						setTransitionGameCategory={setTransitionGameCategory}
						setFetchedGameCategories={setFetchedGameCategories}
						setTransitionGameName={setTransitionGameName}
						setFetchedGames={setFetchedGames}
						selectedTransitionType={selectedTransitionType}
					/>
				</div>
			)}
		</>
	);
};

export default React.memo(AdditionalFields);
